module.exports = __webpack_public_path__ + "logo.351b82e64e2edd717984.png";


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = 8